import styled from "styled-components"

type StyledProps = {
  $disableDelete?: boolean
}

export const Container = styled.div<StyledProps>`
&:hover {
  cursor: ${p => p.$disableDelete ? "default": "pointer"};
}
`

export const Info = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  position: relative;
  padding: 1rem 0;
  border-bottom: 0.1rem solid ${p => p.theme.colors.borderLight};
`

export const Code = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1.8rem;

  span {
    display: flex;
    align-items: center;
  }

  svg {
    margin-right: 1rem;
    height: 1.5rem;
  }
`

export const Remove = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.3rem;
  margin-top: 2rem;

  svg {
    margin-right: 0.5rem;
    height: 1.3rem;
  }
`

export const ExpandIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 1rem 1rem;
  position: absolute;
  bottom: 0;
  right: 0;

  svg {
    height: 1.8rem;
  }

`

export const Comment = styled.div`
display: flex;
  align-items: center;

  svg {
    margin-right: 1rem;
    height: 1.5rem;
  }
`

export const DeleteButton = styled.div`
  display: flex;
  align-items: center;
  margin-right: 2rem;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  svg {
    margin-right: 0.5rem;
  }
`
